<template>
  <div>

    <!-- SELETTORE AZIENDA -->
    <SwitcherAziende />

    <!-- TAGLINE PAGINA -->
    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem" />

    <!-- CARD CONTAINER PRINCIPALE -->
    <b-card
      class="mr-1 ml-1 pic-card"
      :class="{ 'overflow-layout': overflowLayout }"
    >

      <!-- HEADER FISSO -->
      <PICHeader
        :activeTab="activeTab"
        @change-tab="activeTab = $event"
      />

      <!-- CORPO DASHBOARD -->
      <div class="pic-body">
        <PICPiani
          v-if="activeTab === 'piani'"
          @layout-mode="onLayoutMode"
        />
         <PICMacrocategorie
          v-else
          @layout-mode="onLayoutMode"
        />
      </div>
    </b-card>
  </div>
</template>

<script>

import PICHeader from "@/components/pic/PICHeader.vue";
import PICPiani from "@/components/pic/PICPiani.vue";
import PICMacrocategorie from "@/components/pic/PICMacrocategorie.vue";
import PageTagline from "@/components/PageTagline.vue";
import SwitcherAziende from "@/components/refaziendale/SwitcherAziende.vue";

export default {

  name: "PICDash",

  components: {
    PICHeader,
    PICPiani,
    PICMacrocategorie,
    PageTagline,
    SwitcherAziende
  },

  data() {
    return {
      activeTab: "piani",
      overflowLayout: false,
      tagline_elem: [
        {
          text: "Dashboard Welfare PIC",
          link: "pic-dashboard"
        }
      ]
    };
  },
  methods: {
     onLayoutMode(payload) {
       this.overflowLayout = payload.overflow;
     }
  }
};

</script>
<style scoped>
.pic-card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px); /* header + tagline + margin */
  overflow: hidden;
  /* Rimuove il bordo Bootstrap della card contenitore */
  border: none;
}

.pic-card.overflow-layout {
  height: auto;
  min-height: calc(100vh - 120px);
}

.pic-card.overflow-layout .pic-body {
    overflow: visible;
}

.pic-card > .card-body {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.pic-body {
  flex: 1;
  display: flex;
  margin-top: 18px;
  flex-direction: row;  
  overflow: hidden;
}

</style>